import cls from 'classnames';
import React from 'react';

import Dialog from 'click-controls/controls/dialog';

import Button from '../../../../../../../form/button';

export interface IProps {
  className?: string;
  disabled?: boolean;

  onDelete?: () => void;
}

const DialogFooterDelete: React.FC<IProps> = ({ className: pClasssName, disabled, onDelete }) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  const className = React.useMemo(() => {
    return cls('btn-outline-warn text-rose-500', pClasssName, {
      'opacity-50 cursor-default': disabled,
      'mr-auto': !pClasssName?.includes('m')
    });
  }, [pClasssName, disabled]);

  const onDeleteCheck = React.useCallback(() => {
    setIsDeleting(true);
  }, [isDeleting]);

  const closeDelete = React.useCallback(() => {
    setIsDeleting(false);
  }, [isDeleting]);

  return (
    <>
      <Button className={className} disabled={disabled} onPress={onDeleteCheck}>
        Delete
      </Button>
      <Dialog
        cancelText="No"
        centered={true}
        closable={false}
        isOpen={isDeleting}
        okText="Yes"
        title="Confirm Delete"
        width="1/5"
        onCancel={closeDelete}
        onClose={closeDelete}
        onOK={onDelete}
      >
        Are you sure you want to delete this item?
      </Dialog>
    </>
  );
};

export default DialogFooterDelete;
